import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

interface ViewDialogData {
	title: string;
	data: any;
	confirmData: any;
}

@Component({
	selector: 'app-billboard-select-dialog-modal',
	templateUrl: './billboard-select-dialog.component.html',
	styleUrls: ['./billboard-select-dialog.component.scss']
})
export class BillboardSelectDialogComponent implements OnInit {
	constructor(public dialogRef: MatDialogRef<BillboardSelectDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ViewDialogData) {
		//console.log('ViewDialogData', data);
	}

	ngOnInit() {
	}
	selectItemCheck(data) {
		this.dialogRef.close(data);
	}
	closeModal(data): void {
		this.dialogRef.close(data);
	}
}
